import { FAL_ENVELOPE, FAL_MESSAGE_LINES, FAR_BUILDING_COLUMNS, FAR_CREDIT_CARD, FAR_LOCK_KEYHOLE, FAR_MONEY_BILL, FAS_ENVELOPE, FAS_MESSAGE_LINES } from '../const/iconProps';
import { FieldType } from '../const/alertsConfig';
var strings = {
    alertsCategoriesIcons: {
        balanceAlerts: FAR_BUILDING_COLUMNS,
        paymentAlerts: FAR_MONEY_BILL,
        spendingAlerts: FAR_CREDIT_CARD,
        securityAlerts: FAR_LOCK_KEYHOLE,
        payLaterAlerts: FAR_MONEY_BILL
    },
    deliveryIcons: {
        email: FAL_ENVELOPE,
        text: FAL_MESSAGE_LINES
    },
    deliveryIconsSolid: {
        email: FAS_ENVELOPE,
        text: FAS_MESSAGE_LINES
    },
    alertsInputType: {
        available_credit: FieldType.TextField,
        balance_exceeds: FieldType.TextField,
        payment_reminder: FieldType.SelectField,
        promo_purchase_expiry: FieldType.SelectField,
        transaction_over_user_creditlimit: FieldType.TextField
    }
};
export default strings;
